var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, memo, useCallback, useReducer, useEffect } from 'react';
import { blockEditReducer, defaultBlockEditState } from './blockEditReducer';
import { blockEditActions } from './types';
import { useBlock } from '../';
import { usePageEdit } from '../../../ModulePage';
import { BlockType } from '../../../';
var store = createContext({
    blockEdit: defaultBlockEditState,
    dispatchBlockEdit: function () {
    },
    onBlockChange: function () {
    }
});
var Provider = store.Provider;
export var useBlockEdit = function () { return React.useContext(store); };
export var BlockEditProvider = memo(function (_a) {
    var id = _a.id, children = _a.children;
    var _b = useReducer(blockEditReducer, defaultBlockEditState), blockEdit = _b[0], dispatchBlockEdit = _b[1];
    var pageInEditMode = usePageEdit().pageInEditMode;
    var block = useBlock(id).block;
    useEffect(function () {
        dispatchBlockEdit({ type: blockEditActions.TOGGLE_EDIT, enabled: pageInEditMode });
    }, [pageInEditMode]);
    var onBlockChange = useCallback(function (data) {
        switch (block._type) {
            case BlockType.IMAGE:
                block.backgroundImage !== Object.values(data)[0]
                    ? dispatchBlockEdit({ type: blockEditActions.ADD, block: __assign(__assign({}, block), { backgroundImage: Object.values(data)[0] }) })
                    : dispatchBlockEdit({ type: blockEditActions.REMOVE });
                break;
            case BlockType.TEXT:
                block.text !== Object.values(data)[0]
                    ? dispatchBlockEdit({ type: blockEditActions.ADD, block: __assign(__assign({}, block), { text: Object.values(data)[0] }) })
                    : dispatchBlockEdit({ type: blockEditActions.REMOVE });
                break;
            default:
                console.log("edit:::", __assign(__assign({}, block), Object.values(data)[0]));
                block._type !== Object.values(data)[0]
                    ? dispatchBlockEdit({ type: blockEditActions.ADD, block: __assign(__assign({}, block), { _type: Object.values(data)[0] }) })
                    : dispatchBlockEdit({ type: blockEditActions.REMOVE });
                break;
        }
    }, [dispatchBlockEdit, block]);
    return (React.createElement(Provider, { value: { blockEdit: blockEdit, dispatchBlockEdit: dispatchBlockEdit, onBlockChange: onBlockChange } }, children));
});
